import React, { FC } from 'react'
import classNames from 'classnames'
import images from '../../../../app/utlis/image'
import { motion } from 'framer-motion'

interface AIBusinessIdeaProjectProps {
    aiBusinessData: any
}

const AIBusinessIdeaProject: FC<AIBusinessIdeaProjectProps> = ({ aiBusinessData }) => {
    return (
        <div className='flex flex-col gap-5 sm:gap-8 md:gap-10 bg-darkGreyPrimary'>
            {aiBusinessData.AiBusinessesIdeaProjectsData.map((projects: any, idx: number) => {
                return (
                    <motion.div 
                        key={idx}
                        initial={{ 
                            opacity: 0, 
                            x: idx % 2 === 0 ? 50 : -50 
                        }}
                        whileInView={{ 
                            opacity: 1, 
                            x: 0 
                        }}
                        viewport={{ once: false, margin: "-100px" }}
                        transition={{ 
                            duration: 0.7, 
                            ease: "easeOut", 
                            delay: 0.1 
                        }}
                        className={`flex flex-col justify-center ${idx % 2 === 0 ? 'md:flex-row-reverse' : 'md:flex-row'} px-4 sm:px-8 md:px-40 gap-4 sm:gap-6 md:gap-10 h-auto md:h-96`}
                    >
                        <motion.div 
                            className={`w-full md:w-2/5 h-auto overflow-hidden`}
                            whileHover={{ scale: 1.03 }}
                            transition={{ duration: 0.3 }}
                        >
                            <motion.img 
                                src={images.ENTERPRISEBUSINESS} 
                                className='h-auto w-full overflow-hidden' 
                                whileHover={{ scale: 1.05 }}
                                transition={{ duration: 0.5 }}
                            />
                        </motion.div>
                        <motion.div 
                            className={classNames('flex flex-col w-full md:w-2/4', `justify-center`)}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false }}
                            transition={{ 
                                duration: 0.5, 
                                delay: 0.3 
                            }}
                        >
                            <div className={classNames('font-semibold text-2xl sm:text-3xl md:text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                            <div className={classNames('text-greyQuaternary text-base sm:text-lg pt-2 sm:pt-4', `text-${projects.text}`)}>{projects.subtitle}</div>
                        </motion.div>
                    </motion.div>
                )
            })}
        </div>
    )
}

export default AIBusinessIdeaProject